import Loadable from "@loadable/component"
export const loadableP5 = Loadable(() => import("react-p5-wrapper"))
